/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { interviewBookingTokenResponseMeetingLocationTypeSchema } from './InterviewBookingTokenResponseMeetingLocationTypeSchema'
import { interviewBookingTokenResponseStatusSchema } from './InterviewBookingTokenResponseStatusSchema'

export const interviewBookingTokenResponseSchema = z.object({
	id: z.string(),
	candidateId: z.string(),
	token: z.string(),
	bookingUrl: z.string(),
	status: interviewBookingTokenResponseStatusSchema,
	expiresAt: z.iso.datetime(),
	createdAt: z.iso.datetime(),
	durationMinutes: z.number(),
	minAdvanceNoticeHours: z.number(),
	bookingWindowDays: z.number(),
	meetingLocationType: interviewBookingTokenResponseMeetingLocationTypeSchema,
	meetingLocationDetails: z.string().nullable(),
	description: z.string().nullable(),
	deliveryChannels: z.array(z.union([z.literal('email'), z.literal('whatsapp')])),
})

export type InterviewBookingTokenResponseSchema = z.infer<typeof interviewBookingTokenResponseSchema>
